module.exports = __webpack_public_path__ + "27759e5ebf1617eb0dc5e3dd2f18b23a.png";